import type { UI_LANGUAGE, USER_LANGUAGE_SETTING } from 'cpool-constants';
import {
    DEFAULT_UI_LANGUAGE,
    DEFAULT_USER_LANGUAGE_SETTING,
    UI_LANGUAGES,
    USER_LANGUAGE_SETTINGS,
} from 'cpool-constants';

export const SUPPORTED_UI_LANGUAGES = Object.values(UI_LANGUAGES);

const isUiLanguage = (value: string | undefined): value is UI_LANGUAGE =>
    SUPPORTED_UI_LANGUAGES.includes(value as UI_LANGUAGE);

/**
 * Picks the first browser/system language the interface actually supports. Falls back to the product
 * default (German) when the browser asks for something we don't translate.
 */
export const detectBrowserLanguage = (): UI_LANGUAGE => {
    const preferred = navigator.languages?.length ? navigator.languages : [navigator.language];

    return preferred.map((tag) => tag?.toLowerCase().split('-')[0]).find(isUiLanguage) ?? DEFAULT_UI_LANGUAGE;
};

/**
 * Turns a stored user preference into the language the interface is rendered in. `auto` defers to the
 * browser/system language; an unknown preference falls back to the product default.
 */
export const resolveLanguageSetting = (setting: USER_LANGUAGE_SETTING | null | undefined): UI_LANGUAGE => {
    const effective = setting ?? DEFAULT_USER_LANGUAGE_SETTING;

    return effective === USER_LANGUAGE_SETTINGS.auto ? detectBrowserLanguage() : effective;
};
